import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { SnActionConfig } from '@lib/ui/actions';

@Component({
  selector: 'sn-drawer-header',
  templateUrl: './drawer-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'sn-drawer__header',
  },
})
export class SnDrawerHeaderComponent {
  @Input()
  public title: string;

  @Input()
  public titleId: string;

  @Input()
  public actions: SnActionConfig[];

  @Input()
  public context: any;

  constructor() {}
}
